var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextToSpeechPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.189,
    cy: 15.912,
    r: 15,
    fill: "#fff",
    stroke: "#1253FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 12.396c.204-1.509 1.533-2.36 2.947-1.797.891.355 2.06.887 3.564 1.687 1.42.755 2.543 1.43 3.414 2 1.54 1.011 1.54 2.973 0 3.983a43.354 43.354 0 01-3.414 2.002c-1.504.798-2.673 1.33-3.564 1.685-1.414.564-2.743-.287-2.947-1.796a28.982 28.982 0 01-.253-3.882c0-1.55.114-2.86.252-3.882z",
    fill: "#1253FA"
  })));
}
export default SvgTextToSpeechPlay;